var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJamesv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 5000 951",
    width: 5000,
    height: 951,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_EiTILe2PxaCLZNqxLfMCnzIO0eGgbCbU"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5000,
    height: 951
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_EiTILe2PxaCLZNqxLfMCnzIO0eGgbCbU)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5000,
    height: 951,
    style: {
      fill: "rgb(170,116,116)"
    },
    fillOpacity: 0
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 4317.424 0 L 4285.515 173.014 L 4532.75 715.014 L 4595.144 580.207 L 4317.424 0 Z ",
    fill: "rgb(255,255,255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 4972.194 0 L 4579.818 818.112 L 4643.302 951 L 5000 165.563",
    fill: "rgb(255,255,255)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 362.635 685.978 C 362.635 778.073 345.298 845.303 310.625 887.582 C 275.952 929.861 220.592 951 144.629 951 C 122.267 951 98.733 948.141 74.11 942.336 C 49.404 936.532 24.781 928.301 0.074 917.471 L 32.988 814.634 C 58.03 825.81 78.382 833.347 94.043 837.332 C 109.621 841.318 124.613 843.31 138.85 843.31 C 180.475 843.31 209.62 830.401 226.203 804.757 C 242.786 779.026 251.078 736.66 251.078 677.661 L 251.078 0.421 L 362.718 0.421",
    fill: "rgb(255,255,255)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 1131.638 951 L 1254.837 951 L 832.648 0.421 L 780.384 119.113",
    fill: "rgb(255,255,255)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 784.823 363.776 L 730.552 231.221 L 410.453 951 L 533.652 951",
    fill: "rgb(255,255,255)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: " M 3894.131 688.025 C 3894.131 769.945 3869.876 834.164 3821.448 880.853 C 3773.02 927.543 3706.175 950.802 3620.994 950.802 C 3561.96 950.802 3510.572 937.377 3466.831 910.611 C 3423.09 883.846 3391.188 846.05 3371.127 797.223 L 3446.605 725.736 C 3459.842 762.762 3482.371 791.751 3514.19 812.872 C 3546.009 833.908 3582.68 844.426 3624.365 844.426 C 3675.424 844.426 3714.972 831.257 3743.009 804.834 C 3771.047 778.496 3785.024 741.299 3785.024 693.241 C 3785.024 653.479 3771.211 618.504 3743.585 588.404 C 3715.959 558.304 3669.587 526.323 3604.468 492.46 C 3528.743 452.698 3475.793 413.533 3445.454 374.968 C 3415.197 336.402 3400.068 288.003 3400.068 229.684 C 3400.068 160.762 3422.432 105.265 3467.078 63.193 C 3511.723 21.121 3571.169 0 3645.332 0 C 3691.128 0 3731.17 9.064 3765.373 27.193 C 3799.659 45.321 3828.272 72.428 3851.376 108.685 L 3779.269 182.481 C 3766.031 158.453 3747.285 139.811 3723.03 126.386 C 3698.775 113.046 3671.724 106.291 3641.796 106.291 C 3600.933 106.291 3568.538 116.894 3544.694 138.187 C 3520.85 159.479 3508.928 187.954 3508.928 223.784 C 3508.928 257.218 3518.466 285.865 3537.623 309.723 C 3556.698 333.58 3594.848 361.371 3651.992 393.267 C 3752.3 449.534 3817.666 498.446 3848.169 540.005 C 3878.92 581.649 3894.131 630.989 3894.131 688.025 Z ",
    fill: "rgb(255,255,255)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: " M 1386.619 951 L 1499.348 951 L 1560.99 534.657 L 1482.43 362.076 L 1386.619 951 Z ",
    fill: "rgb(255,255,255)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: " M 1868.526 950.802 L 2229.579 169.839 L 2200.266 0 L 1868.526 719.55 L 1537.037 0.398 L 1507.64 169.839",
    fill: "rgb(255,255,255)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: " M 2350.684 951 L 2237.787 951 L 2176.313 534.657 L 2254.788 362.076 L 2350.684 951 Z ",
    fill: "rgb(255,255,255)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 3186.945 138.377 C 3183.386 111.846 3083.041 94.498 3055.148 90.076 C 2733.534 38.203 2580.454 245.495 2580.454 446.524 C 2580.454 645.336 2741.346 802.014 2940.675 802.014 C 2986.936 802.014 3135.951 781.847 3186.945 644.833 C 3145.022 687.947 3084.592 691.774 3061.769 691.774 C 2923.596 691.774 2821.622 584.697 2821.622 446.524 C 2821.622 308.351 2904.619 216.922 3061.769 176.598 C 3157.607 153.738 3188.488 166.61 3186.945 138.377 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 2848.027 322.473 C 2860.165 341.119 2947.615 473.454 3039.533 515.339 C 2982.403 575.113 2884.903 513.515 2824.897 478.603 Q 2764.891 443.691 2795.984 374.856 Q 2825.299 335.607 2848.027 322.473 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 3021 812.872 C 3068.156 796.5 3089.391 790.172 3125 763 C 3147.717 786.026 3213.097 851.281 3166.272 950.802 C 3112.185 837.991 3057.78 826.162 3021 812.872 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 3053.475 67.943 Q 2941.447 -30.653 2790.058 14.721 C 2701.959 38.903 2643.198 109.964 2598.893 199.764 Q 2449.215 240.391 2393.101 390.249 C 2488.242 323.172 2536.798 346.09 2567 365 C 2598.667 190.667 2761.333 21 3053.475 67.943 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamesv);
export default __webpack_public_path__ + "static/media/jamesv.0674ef59df4ccb80835d7ed4bcc5a6b6.svg";
export { ForwardRef as ReactComponent };